import Navigo from 'navigo';
import {
  authRoute,
  canvasRoute,
  loginRoute,
  logoutRoute,
  profilerRoute,
  removebgRoute,
  templateManagerRoute,
  projectsRoute,
  homeRoute,
  productsRoute,
  aiRoute,
} from './routes';

export const router = new Navigo();

export const initRouter = () => {
  // Prevent the browser from restoring scroll position across SPA navigations.
  try {
    if (
      typeof window !== 'undefined' &&
      'scrollRestoration' in window.history
    ) {
      window.history.scrollRestoration = 'manual';
    }
  } catch (e) {
    // ignore if not supported
  }
  router
    .on('/', homeRoute)
    .on('/auth', authRoute)
    .on('/canvas', canvasRoute)
    .on('/canvas/:id', canvasRoute)
    .on('/template-manager', templateManagerRoute)
    .on('/template-manager/:id', templateManagerRoute)
    .on('/login', loginRoute)
    .on('/logout', logoutRoute)
    .on('/profile', profilerRoute)
    .on('/credits', removebgRoute)
    .on('/projects', projectsRoute)
    .on('/products', productsRoute)
    .on('/ai', aiRoute)
    .resolve();
};
